import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import { post } from '../../../helpers/api_helper';
import * as types from './actionTypes';
import {
  fetchReimbursementMappedheadsFailure,
  fetchReimbursementMappedheadsSuccess,
  fetchReimbursementMappedsubheadsSuccess,
  fetchReimbursementMappedsubheadsFailure
} from './actions';

function* fetchHeadsSaga(action) {
  const { unit_id, create_by } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);
    formData.append('create_by', create_by);
    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_HEADS, formData);
    yield put({ type: types.FETCH_REIMBURSEMENT_HEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_REIMBURSEMENT_HEADS_FAILURE, payload: error.message });
  }
}

function* saveHeadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_REIMBURSEMENT_HEAD, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Reimbursement Head!');
    }

    yield put({ type: types.SAVE_REIMBURSEMENT_HEAD_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');

  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_REIMBURSEMENT_HEAD_FAILURE, payload: error });
  }
}

function* changeHeadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_HEAD_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update head status!');
    }

    yield put({ type: types.CHANGE_REIMBURSEMENT_HEAD_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_REIMBURSEMENT_HEAD_STATUS_FAILURE, payload: error });
  }
}


// 1. Fetch Subheads
function* fetchSubheadsSaga(action) {
  const { unit_id, head_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_SUB_HEADS, formData);
    yield put({ type: types.FETCH_REIMBURSEMENT_SUBHEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_REIMBURSEMENT_SUBHEADS_FAILURE, payload: error.message });
  }
}

// 2. Save Subhead
function* saveSubheadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_REIMBURSEMENT_SUB_HEAD, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Subhead!');
    }

    yield put({ type: types.SAVE_REIMBURSEMENT_SUBHEAD_SUCCESS, payload: response });

    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_REIMBURSEMENT_SUBHEAD_FAILURE, payload: error });
  }
}

// 3. Change Subhead Status
function* changeSubheadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_SUB_HEAD_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to update subhead status!');
    }

    yield put({ type: types.CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_SUCCESS, payload: response });

    Swal.fire('Success', response?.message || 'Status updated successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_FAILURE, payload: error });
  }
}

function* fetchReimbursementMappedheadsSaga(action) {
  try {
    const { unit_id, head_id, create_by } = action.payload;
    const formData = new FormData();
    formData.append('head_id', head_id);
    formData.append('unit_id', unit_id);
    formData.append('create_by', create_by);
    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_MAPPED_HEADS, formData);
    yield put(fetchReimbursementMappedheadsSuccess(response.data));
  } catch (error) {
    yield put(fetchReimbursementMappedheadsFailure(error.message || 'Something went wrong'));
  }
}

function* fetchMappedHeadsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_MAPPED_HEADS_LIST, formData);
    yield put({ type: types.FETCH_MAPPED_HEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_MAPPED_HEADS_FAILURE, payload: error.message });
  }
}

function* saveMappedHeadSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MAPPED_HEADS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save Mapped Head!');
    }

    yield put({ type: types.SAVE_MAPPED_HEAD_SUCCESS, payload: response.data });

    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.SAVE_MAPPED_HEAD_FAILURE, payload: error.message });
  }
}

function* changeMappedHeadStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_MAPPED_HEADS_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.CHANGE_MAPPED_HEAD_STATUS_SUCCESS, response });

    Swal.fire('Success', response.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while changing the status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.CHANGE_MAPPED_HEAD_STATUS_FAILURE, payload: error.message });
  }
}

function* fetchReimbursementGridHeadsSaga(action) {
  const { unit_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_GRID_HEADS, formData);
    yield put({ type: types.FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE, payload: error.message });
  }
}

function* fetchReimbursementMappedsubheadsSaga(action) {
  try {
    const { unit_id, head_id } = action.payload;
    const formData = new FormData();
    formData.append('head_id', head_id);
    formData.append('unit_id', unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_MASTER_MAPPING_SUB_HEADS, formData);
    yield put(fetchReimbursementMappedsubheadsSuccess(response.data));
  } catch (error) {
    yield put(fetchReimbursementMappedsubheadsFailure(error.message || 'Something went wrong'));
  }
}

export default function* reimbursementMasterSaga() {
  yield takeLatest(types.FETCH_REIMBURSEMENT_HEADS_REQUEST, fetchHeadsSaga);
  yield takeLatest(types.SAVE_REIMBURSEMENT_HEAD_REQUEST, saveHeadSaga);
  yield takeLatest(types.CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST, changeHeadStatusSaga);

  // Subhead Sagas
  yield takeLatest(types.FETCH_REIMBURSEMENT_SUBHEADS_REQUEST, fetchSubheadsSaga);
  yield takeLatest(types.SAVE_REIMBURSEMENT_SUBHEAD_REQUEST, saveSubheadSaga);
  yield takeLatest(types.CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST, changeSubheadStatusSaga);

  yield takeLatest(types.FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST, fetchReimbursementMappedheadsSaga);

  yield takeLatest(types.FETCH_MAPPED_HEADS_REQUEST, fetchMappedHeadsSaga);
  yield takeLatest(types.SAVE_MAPPED_HEAD_REQUEST, saveMappedHeadSaga);
  yield takeLatest(types.CHANGE_MAPPED_HEAD_STATUS_REQUEST, changeMappedHeadStatusSaga);
  yield takeLatest(types.FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST, fetchReimbursementGridHeadsSaga);

  yield takeLatest(types.FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST, fetchReimbursementMappedsubheadsSaga);
}